import React from 'react';
import versionHelper from '../../../../infrastructure/helpers/functions/common/versionHelper';
import ColumnDefinition from '../../../../infrastructure/types/DataGrid/ColumnDefinition';
import Version from '../../../../types/common/Version';
import CustomIcon from '../../../Common/BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../../../Common/BootstrapIcons/Tooltip/IconTooltip';
import EditableText from '../../../Common/EditableText/EditableText';
import PromiseButton from '../../../Common/PromiseButton';
import { ReactComponent as EditIcon } from '../../../Common/BootstrapIcons/edit.svg';

const getColumns = (onGetChangesClick: (identifier: string) => Promise<void>, onEditClick?: (x: Version) => void): ColumnDefinition<Version>[] => {
    return [
        {
            header: 'Version',
            getContent: x => versionHelper.getDisplayName(x.identifier),
            width: '90px'
        },
        {
            header: 'Change Name',
            getContent: x => x.name,
            width: '200px',
            className: 'break-all'
        },
        {
            header: 'Change Comment',
            getContent: x => <EditableText
                value={x.comment}
                onChange={() => { }}
                multiline={true}
                disabled={true}>
            </EditableText>,
            className: 'break-all'
        },
        {
            header: 'Timestamp',
            getContent: x => x.timestamp,
            sortKey: 'Timestamp',
            width: '180px'
        },
        {
            header: 'User',
            getContent: x => x.user
        },
        {
            header: 'Actions',
            getContent: x =>
                <>
                    <button className="custom-icon-button" onClick={() => onEditClick && onEditClick(x)}>
                        <CustomIcon icon={EditIcon} title={iconTooltip.edit} />
                    </button>
                </>
        },
        {
            header: '',
            getContent: x => <PromiseButton className="transparent-button" enableOnErrorOnly={false} task={() => onGetChangesClick(x.identifier)} text="Changes" />,
            width: '80px'
        }
    ];
}

export default getColumns;